<select [formControl]="formControl">
  <option *ngFor="let typeName of shippingSettings" [value]="typeName">
    {{ typeName }}
  </option>
</select>
